"use client";

export { InfiniteProductList } from "./InfiniteProductList";
